import React, {Component} from "react";
import {Link} from "react-router-dom";
import HeaderRight from "./HeaderRight";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {search: false};
    }

    render() {
        const searchPopup = (
            <>
                <div className={this.state.search ? 'body-overlay active' : 'body-overlay'} id="body-overlay" onClick={() => this.setState({search: false})} />
                <div className={this.state.search ? 'search-popup active' : 'search-popup'} id="search-popup">
                    <form className="search-form">
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder="Search....." />
                        </div>
                        <button type="button" className="submit-btn"><i className="fa fa-search" /></button>
                    </form>
                </div>
            </>
        );

        return (
            <>
                {this.props.searchPopup ? searchPopup : ''}
                <div className="header-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-3 col-3">
                            { (this.props.title !== 'Signin') && (this.props.title !== 'Verification') ?
                                <Link className="menu-back-page home-clicked" to={'/'}>
                                    <i className="fa fa-home" />
                                </Link>
                            : ''}    
                            </div>
                            <div className="col-sm-6 col-6 text-center">
                                <div className="page-name">{this.props.title}</div>
                            </div>
                            <div className="col-sm-3 col-3 text-right">
                                <HeaderRight />
                                
                            </div>
                        </div>
                    </div>
                </div>

                {/* Page Title */}
            {/*
                { (this.props.title != 'Signin') && (this.props.title != 'Verification') ? 
                <div className="page-title mg-top-50">
                    <div className="container">
                        <Link className="float-left home-clicked" to={'/'}>Home</Link>
                        <span className="float-right">{this.props.title}</span>
                    </div>
                </div>
                : <div className="pad-top-40"></div>}
            */}        
            </>
        );
    }
}

export default Header;